module.exports = "<p>\n  track-order works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/track-order/track-order.component.html
// module id = ./src/app/components/account/track-order/track-order.component.html
// module chunks = main